module.exports = __webpack_public_path__ + "img/product_81.87a44cf.webp";